import { render, staticRenderFns } from "./ImpersonationBanner.vue?vue&type=template&id=7f8596eb&scoped=true"
import script from "./ImpersonationBanner.vue?vue&type=script&lang=js"
export * from "./ImpersonationBanner.vue?vue&type=script&lang=js"
import style0 from "./ImpersonationBanner.vue?vue&type=style&index=0&id=7f8596eb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8596eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f8596eb')) {
      api.createRecord('7f8596eb', component.options)
    } else {
      api.reload('7f8596eb', component.options)
    }
    module.hot.accept("./ImpersonationBanner.vue?vue&type=template&id=7f8596eb&scoped=true", function () {
      api.rerender('7f8596eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/ImpersonationBanner.vue"
export default component.exports